export const LANDING = {
  header: 'site-header',
  headerLogo: 'header-logo',
  headerBookBtn: 'header-book-btn',
  headerCallBtn: 'header-call-btn',
  navTests: 'nav-tests',
  navHowItWorks: 'nav-how-it-works',
  navAreas: 'nav-areas',
  navReports: 'nav-reports',

  heroBookBtn: 'hero-book-btn',
  heroViewTestsBtn: 'hero-view-tests-btn',
  heroOrderKitBtn: 'hero-order-kit-btn',

  pricingBasicBookBtn: 'pricing-basic-book-btn',
  pricingTankBookBtn: 'pricing-tank-book-btn',
  pricingBoreBookBtn: 'pricing-bore-book-btn',

  finalCtaBtn: 'final-cta-btn',
  problemCard: (slug) => `problem-card-${slug}`,
  serviceAreaPill: (slug) => `area-pill-${slug}`,

  footer: 'site-footer',
};

export const BOOKING = {
  page: 'booking-page',
  stepper: 'booking-stepper',
  // Step 1
  testCardBasic: 'booking-test-basic',
  testCardTank: 'booking-test-tank',
  testCardBore: 'booking-test-bore',
  expertAdviceToggle: 'booking-expert-advice-toggle',
  step1Next: 'booking-step1-next',
  // Step 2
  inputName: 'booking-input-name',
  inputMobile: 'booking-input-mobile',
  inputEmail: 'booking-input-email',
  inputAddress: 'booking-input-address',
  inputSampleType: 'booking-input-sample-type',
  step2Back: 'booking-step2-back',
  step2Next: 'booking-step2-next',
  // Step 3 (Payment)
  cardNumber: 'booking-card-number',
  cardExpiry: 'booking-card-expiry',
  cardCvc: 'booking-card-cvc',
  step3Back: 'booking-step3-back',
  payBtn: 'booking-pay-btn',
  // Confirmation
  confirmationRef: 'booking-confirmation-ref',
  homeBtn: 'booking-home-btn',
};
